import { createAction } from '@reduxjs/toolkit'

export const setPriceData = createAction<any []>('price/setPriceData')
